'use strict'

import Axios from 'axios'
import configuration from '../../configuration'
import { callbackify } from 'util';

export default class RequestService {
  static validade(request) {
    let errors = []
    if (!request.contract) errors.push('contrato')

    if (errors.length > 0) return errors
    else return null
  }

  static async findAll() {
    try {
      let response = await Axios.get(`${configuration.apiHost}requests/`)
      return response.data
    } catch (error) {
      throw new Error(error)
    }
  }

  static async create(request) {
    try {
      let saved = await Axios.post(
        `${configuration.apiHost}requests/`,
        request
      )
      return saved.data
    } catch (error) {
      throw new Error(error)
    }
  }

  static async update(request) {
    try {
      let updated = await Axios.put(
        `${configuration.apiHost}requests/`,
        request
      )
      return updated.data
    } catch (error) {
      throw new Error(error)
    }
  }
  static async sliptArrays(array, index) {
    let repetir = true;
    let arrayCopied = JSON.parse(JSON.stringify(array));//copiar Array
    let matriz=[];
    let arrParticionado=[]
    let indexesNulls = 0;
    let posicao=[];
    while(repetir){
      if(indexesNulls==arrayCopied.length) repetir = false;
      else{
        arrParticionado = arrayCopied.filter(function (value,i) {
          if((value.address.cep == arrayCopied[index].address.cep) &&
          (value.address.number == arrayCopied[index].address.number)) {
            indexesNulls++;
            return true;
          }else return false;
        });
        matriz.push(arrParticionado);
        index++;
      }
    }

    return matriz;
  }
  static async formatterContractToRequest(contract) {
    let request = {
      departments: contract.departments ,
      contract: contract._id,
      contractCode: contract.contractCode,
      client: contract.client,
    }
    RequestService.create(request);
  }




}
 // class



// WEBPACK FOOTER //
// ./src/service/RequestService.js